var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74463 10.2812C0.916202 10.2812 0.244629 10.9528 0.244629 11.7812C0.244629 12.6097 0.916202 13.2812 1.74463 13.2812V10.2812ZM29.7109 12.8419C30.2967 12.2561 30.2967 11.3064 29.7109 10.7206L20.1649 1.17465C19.5792 0.588861 18.6294 0.588861 18.0436 1.17465C17.4578 1.76044 17.4578 2.71018 18.0436 3.29597L26.5289 11.7812L18.0436 20.2665C17.4578 20.8523 17.4578 21.8021 18.0436 22.3879C18.6294 22.9736 19.5792 22.9736 20.1649 22.3879L29.7109 12.8419ZM1.74463 13.2812H28.6502V10.2812H1.74463V13.2812Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.19b5326ae2ce8807d136bbc0ac2db0c8.svg";
export { ForwardRef as ReactComponent };